import React, {useEffect, useState} from "react";
import Button from "../../components/v2/Button";
import StepperCar from "../../components/v2/StepperCar";
import Input from "../../components/v2/Input";
import IconGo1 from "../../assets/v2/go1.png";
import IconGo2 from "../../assets/v2/go2.png";

import useValetStore from "./hooks/useValetStore";
import Swal from "sweetalert2";
import {ValetSteps} from "./constants/ValetSteps";
import RadioSelector from "../../components/v2/RadioSelector";
import {RouteType} from "./constants/RouteType";
import {GoogleMapStatus} from "../../constants/GoogleMapStatus";
import Alert, {ERROR} from "../../components/v2/Alert";
import ValetRouteGraph from "./ValetRouteGraph";
import {useTranslation} from "react-i18next";
import {GMapAutocompleteCustom} from "../../components/v2/GMapAutocompleteCustom";
import {APIProvider} from "@vis.gl/react-google-maps";

export default function ValetYourTravel({}) {

    const {
        callPost,
        userData,
        setTravelData
    } = useValetStore();

    // const [fromAddress, setFromAddress] = useState(userData?.travel?.fromAddress ?? "");
    // const [fromCp, setFromCp] = useState(userData?.travel?.fromCp ?? "");
    // const [fromCity, setFromCity] = useState(userData?.travel?.fromCity ?? "");
    //
    // const [toAddress, setToAddress] = useState(userData?.travel?.toAddress ?? "");
    // const [toCp, setToCp] = useState(userData?.travel?.toCp ?? "");
    // const [toCity, setToCity] = useState(userData?.travel?.toCity ?? "");

    const [from, setFrom] = useState(userData?.travel?.from ?? null);
    const [to, setTo] = useState(userData?.travel?.to ?? null);

    const [routeType, setRouteType] = useState(userData?.travel?.routeType ?? RouteType.GOING_AND_COMING);

    const formRef = React.useRef();
    const [errorMessage, setErrorMessage] = useState(null);

    const {t} = useTranslation('common');

    const googleApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    // console.log("googleApiKey", googleApiKey);

    const calculateClickedHandler = (e) => {
        setErrorMessage(null)
        if (!formRef.current.reportValidity()) {
            return;
        }
        callPost('valet_only_search', {
            // 'origin_address': fromAddress,
            // 'origin_zip_code': fromCp,
            // 'origin_city': fromCity,
            // 'destination_address': toAddress,
            // 'destination_zip_code': toCp,
            // 'destination_city': toCity,
            'address_from': from,
            'address_to': to,
            'route_type': routeType
        }, (data) => {
            if (data.valet_intent.gmap_status === GoogleMapStatus.NOT_FOUND) {
                setErrorMessage(t('valet.travel.text'));
                return;
            }
            setTravelData(
                {
                    // fromAddress: fromAddress,
                    // fromCp: fromCp,
                    // fromCity: fromCity,
                    // toAddress: toAddress,
                    // toCp: toCp,
                    // toCity: toCity,
                    from: from,
                    to: to,
                    routeType: routeType
                }
            )
            useValetStore.setState({
                valetIntent: data.valet_intent,
                step: ValetSteps.OUR_PRICE
            });
        }, (failResultData) => {
            Swal.fire({
                text: failResultData.message,
                icon: 'error',
            });
        });
    }

    return <div className="h-full flex flex-col p-4 gap-4">
        <StepperCar value={10}/>
        <div className="text-white text-[30px] font-bold">
            {t('valet.travel.text2')}
        </div>

        <form ref={formRef}>
            <RadioSelector version={"button"} id={"route_type"} value={routeType} values={[
                {value: RouteType.GOING, label: t('valet.travel.text3'), icon: IconGo1},
                {value: RouteType.GOING_AND_COMING, label: t('valet.travel.text4'), icon: IconGo2},
            ]} onChange={(value) => setRouteType(value)}/>

            <div className="flex mt-3">
                <ValetRouteGraph
                    routeType={routeType} halfHeight={true}
                />
                <APIProvider apiKey={googleApiKey}>
                    <div className="grow">
                        <label
                            className="block w-full text-sm font-medium leading-6 text-white">{t('valet.travel.text5')}</label>
                        <GMapAutocompleteCustom
                            required={true}
                            onPlaceSelect={(place) => setFrom(place.formattedAddress)}
                            value={from}
                            placeHolder={t('valet.travel.text19')}
                        />
                        <label
                            className="block w-full text-sm font-medium leading-6 text-white mt-2">{t('valet.travel.text12')}</label>
                        <GMapAutocompleteCustom
                            required={true}
                            onPlaceSelect={(place) => setTo(place.formattedAddress)}
                            value={to}
                            placeHolder={t('valet.travel.text20')}
                        />
                    </div>
                </APIProvider>
            </div>
        </form>
        {errorMessage != null ?
            <Alert type={ERROR}
                   label="Erreur"
                   text={errorMessage}
            /> : null
        }
        <div className="grow"></div>
        <Button text={t('valet.travel.text18')} clickHandler={calculateClickedHandler}/>
    </div>
}